import React from "react";
import {Container, Row, Col, Card, CardHeader, CardBody} from "shards-react";
import {connect} from "react-redux";

// Components
import PageTitle from "../../components/common/PageTitle";
import {requestAllStatistics} from "../../actions/statistics.action";
import CardStat from "../../components/stats/CardStat";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        let uuid = this.props.match.params.id;
        this.props.loadData(uuid);
    }

    render() {
        const data = this.props.statistics.data;

        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title="Dashboard" subtitle="Dashboard" className="text-sm-left mb-3"/>
                </Row>
                <Row>
                    <Col className="col-lg lg-6 mb-8 col-lg-6 mb-6">
                        <Card small className="user-activity mb-4">
                            <CardHeader className="border-bottom">
                                <h6 className="m-0">Statistiques</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Nombre de patients</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.countPatients}</p>
                                </Row>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Nombre de praticiens</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.countPractitioners}</p>
                                </Row>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Markup 3 euros (7 jours)</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.totalDefaultMarkup} euros</p>
                                </Row>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Markup 6 euros (7 jours)</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.totalMarkupFaster} euros</p>
                                </Row>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Commission 10% (7 jours)</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">{(data.totalFee ? data.totalFee.toFixed(2) : 0)} euros</p>
                                </Row>
                                <Row>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Jour</p>
                                    <p className="col-lg lg-3 mb-4 col-lg-3 mb-3">Nombre de consultations</p>
                                </Row>
                                {data.statsTwoWeeks && data.statsTwoWeeks.map(function (data) {
                                    return (
                                        <Row>
                                            <span className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.date}</span>
                                            <span className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.value}</span>
                                            <span className="col-lg lg-3 mb-4 col-lg-3 mb-3">{data.commissionLabel}</span>
                                            <span className="col-lg lg-3 mb-4 col-lg-3 mb-3">{(data.commissionValue ? data.commissionValue.toFixed(2) : '')}</span>
                                        </Row>
                                    )
                                })}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}


const mapDispatchToProps = dispatch => ({
    loadData: () => dispatch(requestAllStatistics()),
});

const mapStateToProps = state => {
    return {
        statistics: state['statistics'],
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);




// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js